import { FC } from 'react';

import StatPageSideBar from '@shared/components/StatPageSideBar';

import { useTitleHook } from '../../bugo/hooks/useTitleHook';

const CouponSettlementContent: FC = () => {
  useTitleHook('쿠폰형 정산');
  return (
    <div className="rounded-lg bg-white p-6 shadow">
      <div className="flex min-h-[240px] items-center justify-center text-sm text-gray-400">
        쿠폰형 정산 영역 (구현 예정)
      </div>
    </div>
  );
};

/**
 * 쿠폰형 답례품 정산 페이지.
 */
export const AgencyAdminGiftSettlementCouponPage: FC = () => (
  <div className="flex">
    <div className="flex flex-col">
      <StatPageSideBar />
    </div>
    <div className="mx-auto max-w-screen-2xl flex-1 px-10 py-8">
      <h1 className="mb-6 text-2xl font-bold text-gray-900">쿠폰형 정산</h1>
      <CouponSettlementContent />
    </div>
  </div>
);
